import state from './checkinState'
import mutations from './checkinMutations'
import actions from './checkinActions'
import getters from './checkinGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
